export class Button {
    constructor(node) {
        if (!node) {
            console.error(`node parameter is required in ${this.constructor.name}, but now node is`, node);
            return;
        }
        this.node = node;
    }

    disable() {
        this.node.disabled = true;
    }

    enable() {
        this.node.disabled = false;
    }

    get disabled() {
        return this.node.disabled;
    }

    get enabled() {
        return !this.disabled;
    }
}



// WEBPACK FOOTER //
// ./node_modules/wg5/src/modules/atoms/button/Button.js